import React, { useState } from "react";
import axios from "axios";
import "./Rating.scss";
import PropTypes from "prop-types";
import { AI_BASE_URL } from "../../config/index";

// Load environment variable

const Rating = ({ reviewId, onRatingSubmit, onSkipRating, token }) => {
  const [rating, setRating] = useState(0);
  const [hoverRating, setHoverRating] = useState(0);

  const handleRatingClick = async (newRating) => {
    try {
      await axios.patch(
        `${AI_BASE_URL}/reviews/${reviewId}`, // Use the AI base URL
        { rating: newRating },
        {
          headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`,
          },
        }
      );

      setRating(newRating);
      if (onRatingSubmit) {
        onRatingSubmit(newRating);
      }
    } catch (error) {
      console.error("Error updating review:", error);
    }
  };

  const renderStars = () => {
    return Array.from({ length: 5 }, (_, i) => (
      <span
        key={i}
        className={`star ${i < (hoverRating || rating) ? "filled" : ""}`}
        onMouseEnter={() => setHoverRating(i + 1)}
        onMouseLeave={() => setHoverRating(0)}
        onClick={() => handleRatingClick(i + 1)}
      >
        <svg
          width="39"
          height="37"
          viewBox="0 0 39 37"
          fill="currentColor"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M19.8 0L24.2454 13.8197H38.6309L26.9928 22.3607L31.4381 36.1803L19.8 27.6393L8.16185 36.1803L12.6072 22.3607L0.969082 13.8197H15.3546L19.8 0Z"
            fill="currentColor"
          />
        </svg>
      </span>
    ));
  };

  return (
    <div className="rating-container">
      <div className="rating-header">
        <div
          style={{
            display: "flex",
            flexDirection: "row",
            gap: "20px",
            alignItems: "center",
          }}
        >
          <span>Évaluez cette réponse ?</span>
          <div className="stars-container">{renderStars()}</div>
        </div>
        <button className="ignore-button" onClick={onSkipRating}>
          Ignorer
        </button>
      </div>
    </div>
  );
};

Rating.propTypes = {
  reviewId: PropTypes.any.isRequired,
  onRatingSubmit: PropTypes.func,
  onSkipRating: PropTypes.func,
};

export default Rating;
